import { render } from "./Alien.vue?vue&type=template&id=4a628620&scoped=true"
import script from "./Alien.vue?vue&type=script&lang=js"
export * from "./Alien.vue?vue&type=script&lang=js"

import "./Alien.vue?vue&type=style&index=0&id=4a628620&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a628620"]])

export default __exports__